// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__12d-3","col":"styles_col__g-YjQ"};